export default (versionDetailsCache) => Boolean(versionDetailsCache?.data?.is_publishing);
